module.exports = __webpack_public_path__ + "img/uid-token-game-guide-jp.2e799309.png";